import { ISiteRole } from '../types/ISiteRole';
import { IResultCodes, ISiteUserActionError } from '../types/IUserActionResult';
import { Request } from './Request';

// If a siteId exists in both 'setSiteRoles' and 'removeFromSiteIds',
// an error should result.
export interface IUpdateServerUsersSiteMembershipParams {
  userIds: string[];
  addToSiteRoles: ISiteRole[];
  removeFromSiteIds: string[];
}

export interface IUpdateServerUsersSiteMembershipResult {
  results?: IUpdateServerUsersSiteMembershipResultCodes[];
  errors?: ISiteUserActionError[];
}

export interface IUpdateServerUsersSiteMembershipResultCodes extends IResultCodes{
  siteId?: number;
}

export class UpdateServerUsersSiteMembershipRequest extends Request<IUpdateServerUsersSiteMembershipParams, IUpdateServerUsersSiteMembershipResult> {
  constructor(params: IUpdateServerUsersSiteMembershipParams) {
    super('updateServerUsersSiteMembership', params);
  }
}
